/*
Copyright 2019 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import * as Leo from '@adobe/leonardo-contrast-colors';
import {
  getContrastRatioInputs
} from './getThemeData';
import {
  addColorScale,
  themeDeleteItem
} from './colorScale';
import {
  themeUpdateParams
} from './themeUpdate';

function addColors(colors) {
  // delete all colors
  // let colorItems = document.getElementsByClassName('themeColor_item');
  // [...colorItems].forEach((el) => {
  //   el.querySelector(`[id$="delete"]`).click()
  //   themeUpdateParams();
  // });

  let ratios = getContrastRatioInputs();
  if (ratios === undefined) ratios = [4.5]

  colors.forEach((color) => {
    const newColor = new Leo.BackgroundColor({
      name: color,
      colorKeys: [color],
      colorspace: 'OKLCH',
      ratios: ratios,
    })
    addColorScale(
      newColor
    )
  })
}

function addColorsBulk(e) {
  let dialog = document.getElementById('addColorsDialog');
  dialog.classList.add("is-open");

  document.getElementById('dialogOverlay').style.display = 'block';
}

function cancelColorsBulk() {
  let dialog = document.getElementById('addColorsDialog');
  dialog.classList.remove("is-open");

  document.getElementById('dialogOverlay').style.display = 'none';
}

function bulkColorsInput(e) {
  let bulkInputs = document.getElementById('bulkColors2');
  let bulkValues = bulkInputs.value.replace(/\r\n/g,";").replace(" ", "").replace(/['\/]/g, "").replace(/["\/]/g, "").replace(/ /g,'').split(";");

  addColors(bulkValues);

  // Hide dialog
  cancelColorsBulk();
  // Run colorinput
  themeUpdateParams();

  // clear inputs on close
  bulkInputs.value = " ";
}

window.addColorsBulk = addColorsBulk;
window.cancelColorsBulk = cancelColorsBulk;
window.bulkColorsInput = bulkColorsInput;

module.exports = {
  addColorsBulk,
  cancelColorsBulk,
  bulkColorsInput
}